import { render, staticRenderFns } from "./UsuarioAdicionarParceiro.vue?vue&type=template&id=49cd0be3"
import script from "./UsuarioAdicionarParceiro.vue?vue&type=script&lang=js"
export * from "./UsuarioAdicionarParceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports